import Button from '@material-ui/core/Button'
import React from 'react'
import SaveIcon from '@material-ui/icons/Create'
import { NewQuestionnaireDialog } from '../../Molecules/NewQuestionnaireDialog'

export function NewQuestionnaireButton() {
  const [openDialog, setOpenDialog] = React.useState(false)
  return (
    <div>
      <Button
        color='inherit'
        id={'newQuestionnaire'}
        startIcon={<SaveIcon />}
        onClick={() => {
          setOpenDialog(true)
        }}
      >
        New
      </Button>
      <NewQuestionnaireDialog open={openDialog} setOpen={setOpenDialog} />
    </div>
  )
}
